import * as R from "@play-co/replicant";
import { SB } from "@play-co/replicant";
import { duration } from "../dateUtils.mjs";
const telegramStateSchema = SB.object({
  internalTelegram: SB.object({
    playerPhotoLastCheckedAt: SB.number().optional(),
    playerPhotoCached: SB.string().optional()
  }).optional()
});
const telegramActions = R.createActions(telegramStateSchema)({
  internalTelegramGetPlayerPhoto: R.asyncAction(async (state, _, api) => {
    state.internalTelegram = {
      playerPhotoLastCheckedAt: api.date.now()
    };
    try {
      state.internalTelegram.playerPhotoCached = await api.telegram.getProfilePictureUrl(api.getUserID(), "160x160") || void 0;
    } catch (error) {
      api.reportError(error instanceof Error ? error : new Error(error));
    }
    return state.internalTelegram.playerPhotoCached;
  })
});
function configureTelegramPlayerPhoto(opts) {
  const { gcinstant, replicantClientPromise } = opts;
  if (gcinstant.platformID !== "telegram") {
    throw Error("Invalid platform: " + gcinstant.platformID);
  }
  const playerPhotoPromise = (async () => {
    const replicant = await replicantClientPromise;
    if (!replicant.invoke.internalTelegramGetPlayerPhoto) {
      throw new Error(
        "No internalTelegramGetPlayerPhoto action found in configuration - make sure to extend Replicant configuration with extendReplicantConfigForAnalytics"
      );
    }
    if (typeof Telegram === "undefined") {
      throw new Error("Telegram SDK is not available");
    }
    if (Telegram.WebApp.initDataUnsafe.user.photo_url) {
      return Telegram.WebApp.initDataUnsafe.user.photo_url;
    }
    const telegramClient = replicant;
    const internalState = telegramClient.state.internalTelegram;
    const now = replicant.now();
    const cacheAge = now - ((internalState == null ? void 0 : internalState.playerPhotoLastCheckedAt) ?? 0);
    const cacheTTL = duration({ hours: 8 });
    const playerPhoto = cacheAge > cacheTTL ? await telegramClient.invoke.internalTelegramGetPlayerPhoto() : internalState == null ? void 0 : internalState.playerPhotoCached;
    return playerPhoto ?? "";
  })();
  gcinstant.beforeStartGameAsync(async () => {
    gcinstant.playerPhoto = await playerPhotoPromise;
  });
}
export {
  configureTelegramPlayerPhoto,
  telegramActions,
  telegramStateSchema
};
